import React, { useState, useEffect } from 'react';
import { MenuIcon, CloseIcon } from './Icons';

const navItems = [
  { href: '#leistungen', label: 'Leistungen' },
  { href: '#ueber-alex', label: 'Über mich' },
  { href: '#bewertungen', label: 'Bewertungen' },
  { href: '#oele-ritual', label: 'Öle & Ritual' },
  { href: '#buchung', label: 'Buchung' }
];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDarkBackground, setIsDarkBackground] = useState(true); // Hero по умолчанию темный

  useEffect(() => {
    const handleScroll = () => {
      
      // Определяем темный или светлый фон под header'ом
      const scrollY = window.scrollY;
      const hero = document.getElementById('hero');
      const services = document.getElementById('leistungen');
      const about = document.getElementById('ueber-alex');
      const testimonials = document.getElementById('bewertungen');
      const oils = document.getElementById('oele-ritual');
      const booking = document.getElementById('buchung');

      // Получаем высоту header'а для более точного определения
      const headerHeight = 80;

      if (hero && scrollY < (hero.offsetHeight - headerHeight)) {
        setIsDarkBackground(true); // Hero - темный
      } else if (services && scrollY >= services.offsetTop - headerHeight && scrollY < services.offsetTop + services.offsetHeight - headerHeight) {
        setIsDarkBackground(false); // Services - светлый
      } else if (about && scrollY >= about.offsetTop - headerHeight && scrollY < about.offsetTop + about.offsetHeight - headerHeight) {
        setIsDarkBackground(true); // About может быть темным
      } else if (testimonials && scrollY >= testimonials.offsetTop - headerHeight && scrollY < testimonials.offsetTop + testimonials.offsetHeight - headerHeight) {
        setIsDarkBackground(false); // Testimonials - светлый
      } else if (oils && scrollY >= oils.offsetTop - headerHeight && scrollY < oils.offsetTop + oils.offsetHeight - headerHeight) {
        setIsDarkBackground(true); // Oils - темный
      } else if (booking && scrollY >= booking.offsetTop - headerHeight) {
        setIsDarkBackground(false); // Booking - светлый
      }
    };
    
    handleScroll(); // Вызываем сразу для начального состояния
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      data-testid="header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md transition-all duration-300 py-4"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button
            data-testid="logo-link"
            className="flex items-center gap-3 group cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <img
              src="/logo.png"
              alt="BodyHarmonic Logo"
              className="h-10 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className={`font-marcellus text-xl transition-colors duration-300 ${
              isDarkBackground ? 'text-brand-light' : 'text-brand-dark'
            }`}>
              BodyHarmonic
            </span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-${item.href.slice(1)}`}
                onClick={(e) => scrollToSection(e, item.href)}
                className={`font-work text-sm font-medium hover:text-brand-gold transition-colors duration-300 relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-brand-gold after:transition-all hover:after:w-full ${
                  isDarkBackground ? 'text-brand-light/90' : 'text-brand-dark/80'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA Button Desktop */}
          <a
            href="#buchung"
            data-testid="cta-header"
            onClick={(e) => scrollToSection(e, '#buchung')}
            className="hidden lg:inline-flex items-center px-6 py-2.5 bg-brand-gold text-brand-dark font-work text-sm font-medium rounded-full transition-all duration-300 hover:bg-brand-dark hover:text-brand-light hover:shadow-lg"
          >
            Termin buchen
          </a>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 hover:text-brand-gold transition-colors duration-300 ${
              isDarkBackground ? 'text-brand-light' : 'text-brand-dark'
            }`}
            aria-label="Menü öffnen"
          >
            {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden absolute top-full left-0 right-0 bg-brand-dark/95 backdrop-blur-md shadow-2xl transition-all duration-300 border-t-2 border-brand-gold/50 ${
          isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => scrollToSection(e, item.href)}
              className="font-work text-base text-brand-light/90 hover:text-brand-gold py-3 border-b border-brand-light/10 transition-colors"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#buchung"
            onClick={(e) => scrollToSection(e, '#buchung')}
            className="mt-4 inline-flex items-center justify-center px-6 py-3 bg-brand-gold text-brand-dark font-work text-sm font-medium rounded-full hover:bg-white transition-all shadow-lg"
          >
            Termin buchen
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;